import axios from '../../utils/axios';
import CRUD from './crud'

const coachBookingDiscounts = new CRUD('coach-booking-discounts', 'superior-judge')

export default Object.assign(
    coachBookingDiscounts,
    {
        reducers: {
            ...coachBookingDiscounts.reducers
        },

    }
)
